import React from 'react';
import RegistroWizard from '@/components/customer-registration/RegistroWizard';
import PublicLayout from '@/components/layout/PublicLayout'; // Usar el nuevo PublicLayout

const RegistroClientePage: React.FC = () => {
  return (
    <PublicLayout>
      {/* RegistroWizard ya contiene el título "Registro de Nuevo Cliente" internamente */}
      <RegistroWizard />
    </PublicLayout>
  );
};

export default RegistroClientePage;